/**
 * Diving Support Checklist
 * When divers are in the water
 * Regulatory: Diving at Work Regs
 */

export const DIVING_SUPPORT_CHECKLIST = {
  id: 'diving_support',
  name: 'Diving Support',
  description: 'When divers are in the water',
  icon: 'Waves',
  regulatory: 'Diving at Work Regs',
  isCustomisable: true,
  items: [
    { id: 'div_1', text: 'Alpha flag displayed', required: true },
    { id: 'div_2', text: 'Engines/thrusters secured or isolated', required: true },
    { id: 'div_3', text: 'Dive supervisor in communication with bridge', required: true },
    { id: 'div_4', text: 'Emergency procedures briefed', required: true },
    { id: 'div_5', text: 'First aid/O2 equipment ready', required: true },
    { id: 'div_6', text: 'Vessel position stable', required: true }
  ]
};
